import React, { useRef, useEffect } from "react";
import VideoPlayer from "../../components/VideoPlayer/VideoPlayer";
import ActionButtonsBar from "../../components/Button/ActionVideoButton";
import EpisodeList from "../../components/Episode/Episode";
import CommentsSection from "../../components/Comments/CommentsSection";
import RecommendationsSection from "../../components/MovieInfor/RecommendMovie";
import MovieInfoBlock from "../../components/MovieInfor/MovieInfor";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import BASE_URL from "../../configs/api";
import axios from "axios";

const WatchPage = () => {
  const { slug } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const [movieData, setMovieData] = React.useState(null);

  const queryParams = new URLSearchParams(location.search);
  const tenPhim = queryParams.get("ten_phim") || "";
  const id = queryParams.get("id") || "";

  useEffect(() => {
    axios
      .get(`${BASE_URL}/api/phim/${slug}`)
      .then((res) => {
        const phim = res.data;
        setMovieData(phim);
      })
      .catch(() => {
        setMovieData(null);
      });
  }, [slug]);

  // Trong WatchPage.js - Cách đơn giản với localStorage
  useEffect(() => {
    // Lấy title từ localStorage khi component mount
    const savedTitle = localStorage.getItem(`movie-title-${slug}`);
    if (savedTitle) {
      document.title = savedTitle;
    }

    if (!slug) return;

    axios
      .get(`${BASE_URL}/api/phim/${slug}`)
      .then((res) => {
        const phim = res.data;
        setMovieData(phim);

        if (phim.ten_phim) {
          const title = `Xem Phim ${phim.ten_phim}`;
          document.title = title;
          localStorage.setItem(`movie-title-${slug}`, title);
        }
      })
      .catch(() => {
        setMovieData(null);
      });
  }, [slug]);

  useEffect(() => {
    if (location.pathname === "/") {
      Object.keys(localStorage).forEach((key) => {
        if (key.startsWith("movie-title-")) {
          localStorage.removeItem(key);
        }
      });
      document.title = "MePhim - Xem Phim Online Miễn Phí!";
    }
  }, [location.pathname]);

  const handleNavigateHome = () => {
    navigate("/");
  };

  const handleNavigateToDetail = () => {
    navigate(`/phim/${slug}`);
  };

  return (
    <div className="bg-[#191b24] text-gray-300">
      <div className="xl:container xl:mx-auto px-4 pb-6">
        {/* Breadcrumb */}
        <div className="py-6">
          <nav className="flex items-center space-x-1 text-sm">
            {/* Home */}
            <div className="flex items-center">
              <button
                onClick={handleNavigateHome}
                className="group flex items-center gap-2  text-gray-400 hover:text-white transition-all duration-300 hover:scale-105"
              >
                <svg
                  className="w-4 h-4"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
                </svg>
                <span className="font-medium">Home</span>
              </button>
            </div>

            {/* Separator */}
            <div className="flex items-center">
              <svg
                className="w-5 h-5 text-gray-600 mx-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </div>

            {/* Movie Detail */}
            <div className="flex items-center">
              <button
                onClick={handleNavigateToDetail}
                className="group flex items-center gap-2  text-gray-400 hover:text-white transition-all duration-300 hover:scale-105"
              >
                <span className="font-medium">Chi tiết phim</span>
              </button>
            </div>

            {/* Separator */}
            <div className="hidden sm:flex items-center">
              <svg
                className="w-5 h-5 text-gray-600 mx-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </div>

            {/* Current Page */}
            <div className="hidden sm:flex items-center">
              <div className="flex items-center gap-2  text-white">
                <span className="font-semibold">
                  Xem phim {movieData?.ten_phim || tenPhim || "Đang tải..."}
                </span>
              </div>
            </div>
          </nav>
        </div>

        <VideoPlayer id={id} />
        <ActionButtonsBar
          onZoomClick={() => videoRef.current?.requestFullscreen()}
        />
      </div>
      <div className="xl:container xl:mx-auto px-4">
        <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
          <div className="w-full lg:w-[70%] xl:w-[75%] min-w-0">
            <MovieInfoBlock slug={slug} />
            <div className="border-l border-white/10 border-opacity-20 border-b-[1px] my-6"></div>
            <EpisodeList slug={slug} />
            <CommentsSection slug={slug} />
          </div>
          <div className="w-full lg:w-[30%] xl:w-[25%] min-w-0 no-border lg:border-l lg:border-white/10 lg:pl-6">
            <div className="rounded-lg space-y-6 md:space-y-8 sticky top-20">
              <RecommendationsSection />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WatchPage;
